export default __webpack_public_path__ + "static/media/MultiVersionSupport_4.ebc2eb53.svg";